<script>
	// Stores
	import { editResultsOpen } from '@/Stores/Store.js';

	export let race;

	$: race && resetManualResult();

	let manualResult = !!(race && race.manual_result);

	function resetManualResult() {
		manualResult = !!(race && race.manual_result);
	}
</script>

<button on:click={() => editResultsOpen.set(true)} class="flex items-center p-1 border rounded-md focus:outline-none">
	<span class="mr-1">Manual Result</span>
	<span class="p-2 {manualResult ? 'bg-green-500' : 'bg-gray-300'} rounded-full" />
</button>
